const dev = {
  STRIPE_KEY: "pk_test_E9eHB5ryxaQhEGv5CULETAky00YLzXnkcf",
  s3: {
    REGION: "us-east-2",
    BUCKET: "password-manager-api-dev-attachmentsbucket-1khlj052rqws8"
  },
  apiGateway: {
    REGION: "us-east-2",
    URL: "https://lc75cok4o9.execute-api.us-east-2.amazonaws.com/dev"
  },
  cognito: {
    REGION: "us-east-2",
    USER_POOL_ID: "us-east-2_jzxnmIzUv",
    APP_CLIENT_ID: "6q6tdcfi0eoab6kahhfdcr0rrc",
    IDENTITY_POOL_ID: "us-east-2:8b601907-5471-4145-8fc5-bcf48c28be25"
  },
};

const SECRET_KEY = "AYA*S%8pjgA,KPWX";

const prod = {
  STRIPE_KEY: "pk_test_E9eHB5ryxaQhEGv5CULETAky00YLzXnkcf",
  s3: {
    REGION: "us-east-2",
    BUCKET: "password-manager-api-prod-attachmentsbucket-v9vdt32rxtfa"
  },
  apiGateway: {
    REGION: "us-east-2",
    URL: "https://nvnbsgca69.execute-api.us-east-2.amazonaws.com/prod"
  },
  cognito: {
    REGION: "us-east-2",
    USER_POOL_ID: "us-east-2_oMsnlRh5W",
    APP_CLIENT_ID: "4c97rubiq7sah2t3abu8ro5rme",
    IDENTITY_POOL_ID: "us-east-2:9b780846-ba2f-4072-8a74-a8560fe26137"
  }
};

// Default to dev if not set
const config = process.env.REACT_APP_STAGE === 'prod'
  ? prod
  : dev;

const exportedConfig = {
  // Add common config values here
  MAX_ATTACHMENT_SIZE: 5000000,
  SECRET_KEY,
  ...config
};

export default exportedConfig;